export default {
  //Pagination common configuration
  
  paginationConfig: {
    "perPage": (window.localStorage.getItem('site_config') != null) ? Number(JSON.parse(window.localStorage.getItem('site_config'))['per_page']):10,
    "pageNumber": 1,
    "pageSize": [10, 25, 50, 100]
  }
}